import React, { useEffect, useState } from 'react';
import SmallCard from './SmallCard';
import { AUTH_CODE, major_cities, zoneMasterheader } from '../constants/constVariables';
import { areaMasterheader } from '../constants/constVariables';
import InfiniteScroll from 'react-infinite-scroll-component';
import DataNotFound from './DataNotFound';
import { listing } from '../constants/MapContainer';
import FooterButton from './FooterButton';
import { Link } from 'react-router-dom';
import { downloadData } from '../constants/Utils';

export default function MapCompnent(props) {
    // console.log("Map Component", props);
    useEffect(() => { listing(props.data,props.zoneMap?"zone":"area") }, [props.data])
    return (
        <>
            {/* <div className="horizontal-line" style={{ margin: "0.5rem 0" }}></div> */}
            <div className='dispatch-container'>
                <div className='dispatch-map-container'>
                    <div className='zone-map-inner'>
                        {
                            props.data.length > 0 ?
                                <>
                                    <div className='zone-map-wrap' style={{ display: "flex", gap: "1rem" }}>
                                        <div className='dashboard-vehicle'>
                                            <>
                                                <div className='zone-header' style={{ justifyContent: "unset" }}>
                                                    {
                                                        props.zoneMap ?
                                                            <span>Total Zones - {props.data.length}</span>
                                                            :
                                                            <span>Total Areas - {props.data.length}</span>
                                                    }
                                                </div>
                                                <InfiniteScroll style={{ backgroundColor: "unset" }}
                                                    next={props.nextFetch}
                                                    dataLength={props.data.length}
                                                    hasMore={props.hasNext}
                                                    loader={<h4>Loading...</h4>}
                                                    scrollThreshold={1}
                                                    height={window.matchMedia('(max-width:1440px)').matches ? 525 : window.innerHeight - 275}
                                                    scrollableTarget="small-card-inner"
                                                // endMessage={<div className='infinite-scroll-loader'> Done </div>}
                                                >
                                                    <div className="small-card-inner">
                                                        {
                                                            props.zoneMap ?
                                                                props.data.map((vin, index) => {
                                                                    return (
                                                                        <SmallCard header={vin.zone_name} editlink="/zone-master/edit-zone" link="/zone-master/zone-details" subheader={zoneMasterheader} data={vin} edit={true} delete={true} key={index} icon={true} authEdit={props?.authOperation?.edit} authDelete={props?.authOperation?.delete} table_name={"zone-details"} />
                                                                    )
                                                                }) :
                                                                props.data.map((vin, index) => {
                                                                    return (
                                                                        <SmallCard header={vin.area_name} editlink="/area-master/edit-area" link="/area-master/area-details" subheader={areaMasterheader} data={vin} edit={true} delete={true} key={index} icon={true} authEdit={props?.authOperation?.edit} authDelete={props?.authOperation?.delete} table_name={"area-details"} />
                                                                    )
                                                                })
                                                        }
                                                    </div>
                                                </InfiniteScroll>
                                            </>
                                        </div>
                                        <div className='zone-map' id='map_container'></div>
                                    </div>
                                    <div className="dashboard-footer" style={{justifyContent: 'flex-end'}}>
                                        {/* <div className="download-filter-btn-container">
                                            <FooterButton shouldEnable={false} value="download csv" backgroundColor="#82C1A7" secondaryColor="#488f71" handle={()=>downloadData(new Array(props.selectedRows.length).fill(true),props.data,props.zoneMap?"Zone":"Area")} authOperation={AUTH_CODE?.DOWNLOAD}/>
                                            <div id="clear-filter" className='clear-filter regularFont' >Clear Filter</div>
                                        </div> */}
                                        {
                                            
                                            props.zoneMap ?
                                            <Link state={{ edit: false }} to="/zone-master/add-new-zone" exact> <FooterButton shouldEnable={false} value="create-new-zone" backgroundColor="#82C1A7" secondaryColor="#488f71" authOperation={AUTH_CODE?.CREATE} /> </Link>:
                                            <Link state={{ edit: false }} to="/area-master/add-new-area" exact> <FooterButton shouldEnable={false} value="create-new-area" backgroundColor="#82C1A7" secondaryColor="#488f71" authOperation={AUTH_CODE?.CREATE} /> </Link>
                                        }
                                    </div>
                                </>
                                : <DataNotFound />
                        }
                    </div>

                </div>
                {/* <div className="horizontal-line" style={{ marginTop: "1rem" }}></div> */}
            </div>
            <style jsx="true">
                {`
                    .small-card:first-child{
                        margin-top: 0.25rem;
                    }
                    .small-card:last-child{
                        margin-bottom: 0.25rem;
                    }
                    .dispatch-map-container{
                        padding-bottom: unset;
                    }
                    .small-card-inner{
                        overflow: hidden scroll;
                        flex-grow: 1;
                        display: flex;
                        flex-direction: column;
                        gap: 10px;
                    }
                    @media only screen and (max-width: 768px){
                        .zone-map{
                            // height: calc(100% - 76px);
                            height: 100%;
                            /* need to changed if height of body increased */
                            margin: unset;
                            flex-direction: column;
                            width: calc(100% );
                        }
                    }
                    @media only screen and (max-width: 425px){
                       
                        .zone-map{
                             height: 70vh;
                        }
                    }
                `}

            </style>
        </>
    )
}